// ************************************************** //
// MOBILE MENU
// ************************************************** //

const mmtoggle = () => {
	const body = document.querySelector('body');
	const header = document.getElementById('header');
	// if closed
	if(!header.classList.contains('mm')) {
		// open menu
		header.classList.add('mm');
		// no scroll
		body.classList.add('ns');
	}
	// if open
	else {
		// close menu
		header.classList.remove('mm');
		// re-enable scroll
		body.classList.remove('ns');
	}
};
